import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { AddressLocationManager } from '@cakeiteasy/web-utils';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { firstValueFrom, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'ui-typeahead-address',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiTypeaheadAddressComponent),
      multi: true,
    },
  ],
  template: `
    <ui-typeahead
      [search]="search"
      [placeholder]="placeholder"
      [(ngModel)]="model"
      (selectItem)="selectItem.emit($event)"
    ></ui-typeahead>
  `,
})
export class UiTypeaheadAddressComponent implements OnInit, ControlValueAccessor {
  @Input() model = '';
  @Input() placeholder = '';
  @Input() countryCode: string;

  @Output() selectItem = new EventEmitter<any>();
  @Output() busySearch = new EventEmitter<Promise<any>>();

  search: (text: Observable<string>) => Observable<any[]>;

  constructor(private addressManager: AddressLocationManager) {}

  ngOnInit(): void {
    this.search = (text$: Observable<string>): Observable<string[]> => {
      return text$.pipe(
        debounceTime(400),
        distinctUntilChanged(),
        filter((term) => term.length > 2),
        switchMap((term) => this.searchAddress(term)),
      );
    };
  }

  private searchAddress(term: string) {
    const search$ = firstValueFrom(this.addressManager.searchAddress(term, this.countryCode));
    this.busySearch.emit(search$);
    return search$;
  }

  writeValue(value: any): void {
    this.model = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onChange(value: any): void {}

  onTouched(): void {}
}
